module.exports = __webpack_public_path__ + "static/img/sright.62146f28.svg";